import { render, staticRenderFns } from "./TodaysMenu.vue?vue&type=template&id=9cab821a&"
import script from "./TodaysMenu.vue?vue&type=script&lang=js&"
export * from "./TodaysMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports